import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { api } from '../../api/client';
import { formatBytes } from './format';
import { statusKey } from './StatusPanel';

interface Target { folder: string; name: string; label: string; sizeBytes: number }

/** Deleting a model frees its space; recipes that use it then report it missing (docs 47, 48). */
export function useDeleteModel(machineId: string) {
  const queryClient = useQueryClient();
  const [done, setDone] = useState('');
  const remove = useMutation({
    mutationFn: (target: Target) => api.deleteModel(machineId, { folder: target.folder, name: target.name }),
    onSuccess: async (result) => {
      setDone(result.deleted ? `Deleted — ${formatBytes(result.freedBytes)} freed.` : 'The file was already gone.');
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['models', machineId] }),
        queryClient.invalidateQueries({ queryKey: ['catalog', machineId] }),
        queryClient.invalidateQueries({ queryKey: statusKey(machineId) }),
      ]);
    },
  });
  const ask = (target: Target) => {
    setDone('');
    if (window.confirm(`Delete ${target.label} (${formatBytes(target.sizeBytes)}) from this machine? Recipes that use it stop working until it is installed again.`)) {
      remove.mutate(target);
    }
  };
  return { ask, done, remove };
}
